import * as Proptypes from "prop-types";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Select from "components/form/Select/Select";
import "features/view/components/Sort/Sort.scss";

const Sort = ({ options, variant = '', isAlignedRight, fontColor }) => {
  const history = useHistory();
  const [ order, setOrder ] = useState();
  const location = useLocation();

  useEffect(
    () => {
      const searchParams = new URLSearchParams(location.search);
      const field = searchParams.get('sort_by');
      const order = searchParams.get('sort_order');
      setOrder(() => `${ field }|${ order }`);
    },
    [ location ]);

  const handleChange = (value) => {
    const values = value.split('|');
    const field = values[0];
    const order = values[1];
    setOrder(() => field ? `${ field }|${ order }` : '');

    const searchParams = new URLSearchParams(location.search);
    searchParams.set('sort_by', field);
    searchParams.set('sort_order', order);
    history.push('?' + searchParams.toString());
  }

  return (
    <div
      className={ `sort-container ${ isAlignedRight ? 'sort-container--flex-end' : '' } ${ fontColor ? 'sort-container--' + fontColor : '' }` }>
      Sorteer op:
      <Select value={ order } items={ options } variant={ variant } onChange={ handleChange }/>
    </div>
  )
}

Sort.propTypes = {
  options: Proptypes.array,
  variant: Proptypes.string,
  isAlignedRight: Proptypes.bool,
  fontColor: Proptypes.string,
}

export default Sort;
